import HeroCarousel from './components/HeroCarousel';
import SlideCarousel from './components/slide-carousel';
import FullscreenOverlay from 'marketing/components/FullscreenOverlay';
import createXhrForm from 'marketing/components/xhrForm';
import { trackEvent } from '@99designs/utils/platform';

document.addEventListener('DOMContentLoaded', () => {
    HeroCarousel.create().start();
    SlideCarousel.create();

    new FullscreenOverlay({
        element: document.querySelector('[data-fullscreen-overlay-id="pro-form-modal"]'),
        options: {
            fixedViewport: true,
            onClose: () => trackEvent('Dismissed Pro Lead Form'),
            onOpen: () => trackEvent('Viewed Pro Lead Form'),
        }
    });

    createXhrForm('[data-pro-modal]');
});



// WEBPACK FOOTER //
// ./js/marketing/pro.js